import { api } from '../../app/api';

/**
 * Caché de rostros descargados de forma privada (con token). Se indexa por jugador + revisión,
 * así un cambio de foto invalida la entrada anterior y se libera su memoria.
 */
class FaceCache {
  private entries = new Map<string, { rev: number; img: Promise<ImageBitmap | null> }>();

  get(playerId: string, rev: number): Promise<ImageBitmap | null> {
    if (rev <= 0) return Promise.resolve(null);
    const e = this.entries.get(playerId);
    if (e && e.rev === rev) return e.img;
    if (e) void e.img.then((b) => b?.close());
    const img = api
      .face(playerId)
      .then((blob) => (blob ? createImageBitmap(blob) : null))
      .catch(() => null);
    this.entries.set(playerId, { rev, img });
    return img;
  }

  /** Para el propio jugador recién editado (sin volver a descargar). */
  put(playerId: string, rev: number, img: ImageBitmap) {
    this.entries.set(playerId, { rev, img: Promise.resolve(img) });
  }

  drop(playerId: string) {
    const e = this.entries.get(playerId);
    if (e) void e.img.then((b) => b?.close());
    this.entries.delete(playerId);
  }
}

export const faceCache = new FaceCache();
